import React from 'react';

const testimonials = [
  {
    quote: "We replaced our entire SDR cold-call workflow with CallPilot. Qualified pipeline went up 40% in the first month.",
    name: "Marcus D.",
    role: "Head of Sales, Series B SaaS",
    avatar: "MD",
  },
  {
    quote: "Our agency runs outbound for 12 clients. CallPilot made it possible to scale without hiring. Margins are incredible.",
    name: "Priya S.",
    role: "Founder, Growth Marketing Agency",
    avatar: "PS",
  },
  {
    quote: "We did 80 customer interviews in two days for our pivot research. Would have taken us 3 weeks the old way.",
    name: "James K.",
    role: "CPO, B2B Startup",
    avatar: "JK",
  },
];

const stats = [
  { value: '2.4M+', label: 'Calls completed' },
  { value: '28%', label: 'Avg. conversion rate' },
  { value: '$0.09', label: 'Per minute, all-in' },
  { value: '<5 min', label: 'To first campaign' },
];

export function SocialProof() {
  return (
    <section className="py-20 px-6">
      <div className="mx-auto max-w-6xl">
        {/* Stats row */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-16">
          {stats.map((s) => (
            <div key={s.label} className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-white tracking-tight mb-1">{s.value}</div>
              <div className="text-sm text-zinc-500">{s.label}</div>
            </div>
          ))}
        </div>

        {/* Divider */}
        <div className="border-t border-white/[0.06] mb-16" />

        {/* Testimonials */}
        <div className="text-center mb-10">
          <span className="text-xs font-mono tracking-widest uppercase text-indigo-400 mb-3 block">What customers say</span>
          <h2 className="text-2xl md:text-3xl font-bold text-white tracking-tight">
            Teams using CallPilot close more
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t) => (
            <div
              key={t.name}
              className="rounded-2xl border border-white/[0.08] bg-white/[0.03] p-6 flex flex-col gap-4"
            >
              {/* Stars */}
              <div className="flex gap-0.5 text-yellow-400 text-sm">★★★★★</div>
              <p className="text-zinc-300 text-sm leading-relaxed flex-1">"{t.quote}"</p>
              <div className="flex items-center gap-3 pt-2 border-t border-white/[0.06]">
                <div className="w-8 h-8 rounded-full bg-indigo-500/20 border border-indigo-500/30 flex items-center justify-center text-xs font-bold text-indigo-300">
                  {t.avatar}
                </div>
                <div>
                  <div className="text-sm font-medium text-white">{t.name}</div>
                  <div className="text-xs text-zinc-500">{t.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
